import { render } from "./LayoutHeaderStepCard.vue?vue&type=template&id=5707a2d8&scoped=true"
import script from "./LayoutHeaderStepCard.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderStepCard.vue?vue&type=script&lang=js"

import "./LayoutHeaderStepCard.vue?vue&type=style&index=0&id=5707a2d8&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5707a2d8"]])

export default __exports__